import styled, { css } from "styled-components"
import media from "src/styles/media"
import Link from "src/components/util/TransitionLink"
import BackgroundImage from "gatsby-background-image"

export const PortfolioItemWrapper = styled(Link)`
    display: block;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 280px;
    margin-bottom: 15px;
    border-radius: 15px;
    box-shadow: 4px 5px 20px rgba(0,0,0, .2);

    &:hover{
        text-decoration: none;
    }

    ${media.lessThan("lg")`
        height: 300px;
    `}

    ${media.lessThan("md")`
        height: 270px;
    `}

    ${media.lessThan("sm")`
        height: 200px;
    `}
`

export const PortfolioItemContent = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  padding: 35px 15px 27px 35px;
  color: var(--white);
  text-align: left;

  ${media.lessThan("lg")`
        padding: 25px 15px 25px 25px;
    `}

  .overlay {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 3;
    opacity: 1;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 30%,
      rgba(20, 7, 58, 1) 94%
    );
    pointer-events: none;

    ${media.lessThan("md")`
            background: linear-gradient(180deg, rgba(0,0,0,0) 20%, rgba(20,7,58,1) 94%);
        `}
  }
`

const cssBG = css`
  position: absolute !important;
  top: -2%;
  left: -2%;
  width: 103%;
  height: 103%;
  background-image: url(${props => props.img || "none"});
  background-size: cover;
  background-position: center center;
  transition: all 0.4s;
  z-index: 1;

  ${PortfolioItemWrapper}:hover & {
    transform: scale(1.1) !important;
  }
`

export const PortfolioItemBG = styled.div`
  ${cssBG}
`

export const PortfolioItemBGFluid = styled(BackgroundImage)`
  ${cssBG}
`

export const PortfolioItemTitle = styled.h1`
  font-size: 29px;
  margin-bottom: 0;
  font-weight: normal;
  z-index: 2;

  ${media.lessThan("md")`
        font-size: 23px;
    `}
`

export const PortfolioItemCategory = styled.h2`
  font-weight: 300;
  font-size: 19px;
  margin-bottom: -6px;
  font-weight: normal;
  opacity: 0.8;
  z-index: 2;

  ${media.lessThan("md")`
        font-size: 17px;
    `}
`
